module.exports = __webpack_public_path__ + "img/more.73309f08.svg";